export const lby = [
  {
    year: 2015,
    count: 1359,
  },
  {
    year: 2016,
    count: 0,
  },
  {
    year: 2017,
    count: 0,
  },
  {
    year: 2018,
    count: 153,
  },
  {
    year: 2019,
    count: 496,
  },
  {
    year: 2020,
    count: 847,
  },
  {
    year: 2021,
    count: 1152,
  },
]
